<script>
  import {PlusIcon, XIcon, Edit3Icon} from 'vue-feather-icons'

  export default {
    components: {
      PlusIcon,
      XIcon,
      Edit3Icon
    },
    props: {
      emails: {
        type: Array,
        required: true
      },
      validation: {
        type: [Array , Object],
        required: true
      }
    },
    methods: {
      addEmail() {
        this.emails.push(
          {
            email: '',
            is_primary: false
          }
        );
      },

      removeEmail(index) {
        this.emails.splice(index, 1)
      },

      enableEdit(index) {
        const email = this.emails[index]
        email.is_edit = true
        this.emails.splice(index, 1)
        this.emails.splice(index, 0, email)
      },

      disableEdit(index) {
        const email = this.emails[index]
        email.is_edit = false
        this.emails.splice(index, 1).splice(index, 0, email)
      },

      handlerFilter() {
        this.$emit('input', this.roles)
      },

      changePrimary(index) {
        const phone = this.phones[index]
        if (phone && phone.is_primary) {
          this.phones.forEach((item, key) => {
            if (key !== index) {
              item.is_primary = false
            }
          })
        }
      },
    }
  }
</script>

<template>
  <div class="form-content pt-1">
    <div v-for="(email, index) in emails" :key="index">
      <div v-if="email.id" class="edit-form-item my-2">
        <div class="item-info">
          <div class="col-md-6 left-ct">
            <p class="tx-value mg-b-0 text-bold">{{ email.email }}</p>
          </div>
          <div class="col-md-6 right-ct">
            <span v-if="email.is_primary" class="block-status border rounded-pill pl-1 pr-3">
              <span class="status-icon status-completed"></span>
              <span class="status-text">Primary</span>
            </span>
          </div>
        </div>
        <div class="action-group mg-l-auto tw-flex-shrink-1">
          <button type="button" class="btn btn-icon button-action button-action-edit" @click="enableEdit(index)">
            <Edit3Icon size="1x" class="custom-class"></Edit3Icon>
          </button>
          <button type="button" class="btn btn-icon button-action button-action-negative" @click="removeEmail(index)">
            <XIcon size="1x" class="custom-class"></XIcon>
          </button>
        </div>
      </div>

      <div v-if="!email.id || email.is_edit" class="border border-radius-20 bg-gray my-3 pd-20">
        <div class="action-group mg-l-auto tw-flex-shrink-1 float-right">
          <button
            type="button"
            class="btn btn-icon button-action button-action-negative"
            @click="email.is_edit ? disableEdit(index) : removeEmail(index)">
            <XIcon size="1x" class="custom-class"></XIcon>
          </button>
        </div>
        <div :class="['form-group', { 'is-invalid': validation['emails.' + index + '.email'] }]">
          <div class="form-group">
            <label class="label-control">Email Address*</label>
            <input v-model="emails[index].email" type="text" class="form-control"/>
            <div class="invalid-feedback">
              {{ validation['emails.' + index + '.email'] }}
            </div>
          </div>
          <div :class="['form-group', { 'is-invalid': validation['emails.' + index + '.is_primary'] }]">
            <label class="label-control">Email Address Type</label>
            <div class="switch-content">
              <label class="switch">
                <input v-model="emails[index].is_primary" type="checkbox" class="input-switch">
                <span class="slider"></span>
              </label>
              <span class="value">Primary</span>
            </div>
            <div class="invalid-feedback">
              {{ validation['emails.' + index + '.is_primary'] }}
            </div>
            <p class="optional pd-t-10 mg-b-0">Primary Addresses will be the staff's system username</p>
          </div>
        </div>
      </div>
    </div>

    <div class="group-button">
      <button type="button" class="btn button-bd-dashed" @click="addEmail">
        <PlusIcon size="1.5x" class="custom-class float-left mr-2"></PlusIcon>
        <span class="item-text">Add email</span>
      </button>
    </div>
  </div>
</template>
